// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__uKkvj","spinner":"Spinner_spinner__O6Vtl","spin":"Spinner_spin__zp2BO"};